import React, { Component } from 'react'
import "./css/ReportGenerationFeature.css"
import { Container, Row, Col } from 'react-bootstrap'

export default class ReportGenerationFeature extends Component {
        render() {
                return (
                        <Container className="p-5" id="report-generation" style={{ width: "75%" }}>
                                <Row>
                                        <Col lg={6} md={12} className="text-center">
                                                <div className="info-heading"><span className="text-primary">REPORT G</span>ENERATION</div>
                                                <p className="info-text-normal" >Generate several type of reports of the data representations and conclusions and download them in different file formats through you phone itself</p>
                                                <Container>
                                                        <Row>
                                                                <div className="col-4 p-3">
                                                                        <img className="file-icon" src="images/HomePage/pdf.png" alt="pie_chart_image"></img><br></br>
                                                                        <p className="font-weight-bold" >PDF</p>
                                                                </div>
                                                                <div className="col-4 p-3">
                                                                        <img className="file-icon" src="images/HomePage/xls.png" alt="pie_chart_image"></img><br></br>
                                                                        <p className="font-weight-bold">EXCEL</p>
                                                                </div>
                                                                <div className="col-4 p-3">
                                                                        <img className="file-icon" src="images/HomePage/html.png" alt="pie_chart_image"></img><br></br>
                                                                        <p className="font-weight-bold">HTML</p>
                                                                </div>
                                                        </Row>
                                                </Container>
                                        </Col>
                                        <Col lg={6} md={12}>
                                                <img src="images/HomePage/report-generation.png" className="about-illustration" alt="data-svg-illustration"></img>
                                        </Col>
                                </Row>
                        </Container>
                )
        }
}
